import {
  targetGroupsListConstants,
  targetGroupsFuseConstants,
  targetGroupsHm5Constants,
  targetGroupsSaConstants,
  targetGroupsVs2jen2Constants,
  targetGroupsUAConstants,
  targetGroupsVs2ngaConstants,
  targetGroupsHmplusConstants,
} from "../_redux-constants";

export function targetGroupsListReducer(
  state = {
    targetGroupsListLoading: false,
    targetGroupsListData: null,
    targetGroupsListError: null,

    targetGroupsFuseListLoading: false,
    targetGroupsFuseListData: null,
    targetGroupsFuseListError: null,

    targetGroupsHm5ListLoading: false,
    targetGroupsHm5ListData: null,
    targetGroupsHm5ListError: null,

    targetGroupsSaListLoading: false,
    targetGroupsSaListData: null,
    targetGroupsSaListError: null,

    targetGroupsVs2jen2ListLoading: false,
    targetGroupsVs2jen2ListData: null,
    targetGroupsVs2jen2ListError: null,

    targetGroupsVs2ngaListLoading: false,
    targetGroupsVs2ngaListData: null,
    targetGroupsVs2ngaListError: null,

    targetGroupsHmplusListLoading: false,
    targetGroupsHmplusListData: null,
    targetGroupsHmplusListError: null,
  },
  action
) {
  switch (action.type) {
    case targetGroupsListConstants.TARGET_GROUPS_LIST_LOADING:
      return Object.assign({}, state, {
        targetGroupsListLoading: true,
        targetGroupsListData: null,
        targetGroupsListError: null,
      });
    case targetGroupsListConstants.TARGET_GROUPS_LIST_SUCCESS:
      return Object.assign({}, state, {
        targetGroupsListLoading: false,
        targetGroupsListData: action.data,
      });
    case targetGroupsListConstants.TARGET_GROUPS_LIST_FAILURE:
      return Object.assign({}, state, {
        targetGroupsListLoading: false,
        targetGroupsListData: null,
        targetGroupsListError: action.error,
      });
    case targetGroupsFuseConstants.TARGET_GROUPS_FUSE_LIST_LOADING:
      return Object.assign({}, state, {
        targetGroupsFuseListLoading: true,
        targetGroupsFuseListData: null,
        targetGroupsFuseListError: null,
      });
    case targetGroupsFuseConstants.TARGET_GROUPS_FUSE_LIST_SUCCESS:
      return Object.assign({}, state, {
        targetGroupsFuseListLoading: false,
        targetGroupsFuseListData: action.data,
      });
    case targetGroupsFuseConstants.TARGET_GROUPS_FUSE_LIST_FAILURE:
      return Object.assign({}, state, {
        targetGroupsFuseListLoading: false,
        targetGroupsFuseListData: null,
        targetGroupsFuseListError: action.error,
      });
    case targetGroupsHm5Constants.TARGET_GROUPS_HM5_LIST_LOADING:
      return Object.assign({}, state, {
        targetGroupsHm5ListLoading: true,
        targetGroupsHm5ListData: null,
        targetGroupsHm5ListError: null,
      });
    case targetGroupsHm5Constants.TARGET_GROUPS_HM5_LIST_SUCCESS:
      return Object.assign({}, state, {
        targetGroupsHm5ListLoading: false,
        targetGroupsHm5ListData: action.data,
      });
    case targetGroupsHm5Constants.TARGET_GROUPS_HM5_LIST_FAILURE:
      return Object.assign({}, state, {
        targetGroupsHm5ListLoading: false,
        targetGroupsHm5ListData: null,
        targetGroupsHm5ListError: action.error,
      });
    case targetGroupsHmplusConstants.TARGET_GROUPS_HMPLUS_LIST_LOADING:
      return Object.assign({}, state, {
        targetGroupsHmplusListLoading: true,
        targetGroupsHmplusListData: null,
        targetGroupsHmplusListError: null,
      });
    case targetGroupsHmplusConstants.TARGET_GROUPS_HMPLUS_LIST_SUCCESS:
      return Object.assign({}, state, {
        targetGroupsHmplusListLoading: false,
        targetGroupsHmplusListData: action.data,
      });
    case targetGroupsHmplusConstants.TARGET_GROUPS_HMPLUS_LIST_FAILURE:
      return Object.assign({}, state, {
        targetGroupsHmplusListLoading: false,
        targetGroupsHmplusListData: null,
        targetGroupsHmplusListError: action.error,
      });
    case targetGroupsUAConstants.TARGET_GROUPS_UA_LIST_LOADING:
      return Object.assign({}, state, {
        targetGroupsUAListLoading: true,
        targetGroupsUAListData: null,
        targetGroupsUAListError: null,
      });
    case targetGroupsUAConstants.TARGET_GROUPS_UA_LIST_SUCCESS:
      return Object.assign({}, state, {
        targetGroupsUAListLoading: false,
        targetGroupsUAListData: action.data,
      });
    case targetGroupsUAConstants.TARGET_GROUPS_UA_LIST_FAILURE:
      return Object.assign({}, state, {
        targetGroupsUAListLoading: false,
        targetGroupsUAListData: null,
        targetGroupsUAListError: action.error,
      });
    case targetGroupsSaConstants.TARGET_GROUPS_SA_LIST_LOADING:
      return Object.assign({}, state, {
        targetGroupsSaListLoading: true,
        targetGroupsSaListData: null,
        targetGroupsSaListError: null,
      });
    case targetGroupsSaConstants.TARGET_GROUPS_SA_LIST_SUCCESS:
      return Object.assign({}, state, {
        targetGroupsSaListLoading: false,
        targetGroupsSaListData: action.data,
      });
    case targetGroupsSaConstants.TARGET_GROUPS_SA_LIST_FAILURE:
      return Object.assign({}, state, {
        targetGroupsSaListLoading: false,
        targetGroupsSaListData: null,
        targetGroupsSaListError: action.error,
      });
    case targetGroupsVs2jen2Constants.TARGET_GROUPS_VS2JEN2_LIST_LOADING:
      return Object.assign({}, state, {
        targetGroupsVs2jen2ListLoading: true,
        targetGroupsVs2jen2ListData: null,
        targetGroupsVs2jen2ListError: null,
      });
    case targetGroupsVs2jen2Constants.TARGET_GROUPS_VS2JEN2_LIST_SUCCESS:
      return Object.assign({}, state, {
        targetGroupsVs2jen2ListLoading: false,
        targetGroupsVs2jen2ListData: action.data,
      });
    case targetGroupsVs2jen2Constants.TARGET_GROUPS_VS2JEN2_LIST_FAILURE:
      return Object.assign({}, state, {
        targetGroupsVs2jen2ListLoading: false,
        targetGroupsVs2jen2ListData: null,
        targetGroupsVs2jen2ListError: action.error,
      });

    case targetGroupsVs2ngaConstants.TARGET_GROUPS_VS2NGA_LIST_LOADING:
      return Object.assign({}, state, {
        targetGroupsVs2ngaListLoading: true,
        targetGroupsVs2ngaListData: null,
        targetGroupsVs2ngaListError: null,
      });
    case targetGroupsVs2ngaConstants.TARGET_GROUPS_VS2NGA_LIST_SUCCESS:
      return Object.assign({}, state, {
        targetGroupsVs2ngaListLoading: false,
        targetGroupsVs2ngaListData: action.data,
      });
    case targetGroupsVs2ngaConstants.TARGET_GROUPS_VS2NGA_LIST_FAILURE:
      return Object.assign({}, state, {
        targetGroupsVs2ngaListLoading: false,
        targetGroupsVs2ngaListData: null,
        targetGroupsVs2ngaListError: action.error,
      });
    default:
      return state;
  }
}
